var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9824 11.0749H17.1253V8.93094C17.1253 8.59512 16.854 8.3238 16.5182 8.3238H8.77708V7.56487C8.77708 7.48139 8.70878 7.41309 8.6253 7.41309H7.5628C7.47931 7.41309 7.41101 7.48139 7.41101 7.56487V22.4399C7.41101 22.5234 7.47931 22.5917 7.5628 22.5917H8.6253C8.70878 22.5917 8.77708 22.5234 8.77708 22.4399V17.4309H13.4824V19.5749C13.4824 19.9107 13.7538 20.1821 14.0896 20.1821H21.9824C22.3183 20.1821 22.5896 19.9107 22.5896 19.5749V11.6821C22.5896 11.3462 22.3183 11.0749 21.9824 11.0749ZM8.77708 16.0649V9.68987H15.7592V16.0649H8.77708ZM21.2235 18.816H14.8485V17.4309H16.9735C17.057 17.4309 17.1253 17.3626 17.1253 17.2792V12.441H21.2235V18.816Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.0585433eb3198a86b8b9b203105a67d0.svg";
export { ForwardRef as ReactComponent };